import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  transactionList : [],
  error : null
};


export const TRANSACTION_LIST = "admin/transaction/list";

export const getTransactionList = createAsyncThunk(
  TRANSACTION_LIST,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(TRANSACTION_LIST, {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTransactionList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transactionList = action.payload;
      })
      .addCase(getTransactionList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logout, () => initialState);
  },
});

export default transactionSlice.reducer;